<template>
    <modal name="competition-filter-entry-filter" class="filter-modal competition-filter-entry-filter"
           :width="`calc(100% - 28px)`" :height="`auto`" :pivotY="0.5"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
      <div>
        <div class="filter_modal_wrap">
          <div class="filter_modal_top">
            <div class="filter_img"></div>
            <div class="filter_name">{{ $t('filter') }}</div>
            <div class="close_btn" @click="modalClose()"></div>
          </div>

<!--          응모작 보기 필터-->
          <div class="mt20 filter_modal_status">
            <div class="modal_title">{{ $t('exposure') }}</div>
            <div class="check_wrap">
              <div class="checkbox inline_block">
                <el-checkbox-group v-model="filterCategory"
                                   @change="setFilterFunc('ic', filterCategory)">
                  <el-checkbox :label="2">{{ $t('b_update') }}</el-checkbox>
                  <el-checkbox :label="5">{{ $t('voteDesc') }}</el-checkbox>
                  <el-checkbox :label="4">{{ $t('scoreDesc') }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>

          <div class="wrapper_bottom">
            <button class="" @click="modalClose">{{ $t('apply2') }}</button>
          </div>

        </div>
      </div>

    </modal>
</template>

<script>
export default {
    name: "CompetitionFilterEntryFilter",
  mixins: [],
  components: {},
  inject: ['setFilter', 'setSort'],
  provide() {
    return {}
  },
  props: {
    modalLayout: '',
  },
  data() {
    return {
      component: null,
      sortData: {},
      searchInputOption: 'ina',
      sort: '',
      sortOption: 'last_update',
      searchInput: '',
      filterCategory: [],
      filterStatus: [],
      filterEdition: [],
      filterType: [],
      priceInput: ['', ''],
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    handlerBeforeOpen(event) {
      this.sortData = event.params.sortData;
      this.setterFilterDataInData();
    },
    handlerOpened() {
    },
    handlerBeforeClose() {
    },
    modalClose() {
      this.$modal.hide('competition-filter-entry-filter');
    },
    setterFilterDataInData() {
      let classnames = Object.keys(this.filterData);
      classnames.forEach(classname => {
        let obj = this.filterData[classname];
        let type = filterConfig[obj.key].type;
        if (this.hasOwnProperty(classname)) {
          if (type == 'query') {
            this[classname] = obj.query;
            if (this.hasOwnProperty(classname + 'Option')) {
              this[classname + 'Option'] = obj.key;
            }
          } else if (type === 'between') {
            this[classname] = [obj.start, obj.end];
          } else if (type === 'match') {
            if (isNaN(obj.value)) {
              this[classname] = obj.value;
            } else {
              this[classname] = Number(obj.value);
            }

          } else if (type === 'terms') {
            this[classname] = obj.terms;
          }

        }
      })
    },

    setFilterFunc(key, value) {
      this.setFilter(key, value);
    },

  },
  watch: {},
}
</script>

<style scoped>

</style>
